export default {
	id: null,
	title: null,
	header: null,
	text: null,
	more_info_url: null,
	image_tagline: null,
	images: {
	  card: {
		 original: '',
		 optimized: '',
	  },
	},
	casino: {

	},
 }


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/models/insight.js